import React, { useEffect } from "react";
import { Check } from "lucide-react";
import { GuideCover, GuideForm } from "../components/km/BuyerGuide";
import BlueprintPeek from "../components/km/BlueprintPeek";
import { BUYER_GUIDE } from "../data/km";

export default function BuyerGuidePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    const prev = document.title;
    document.title = "Free DFW Buyer's Blueprint 2026 | Kristin McIntyre";
    return () => { document.title = prev; };
  }, []);
  return (
    <main className="pt-[76px] md:pt-[84px]" data-testid="buyer-guide-page">
      <section className="px-6 md:px-12 lg:px-16 py-10 md:py-20 lg:py-28 bg-[#F4F3EF]">
        <div className="max-w-[1180px] mx-auto grid lg:grid-cols-2 gap-10 lg:gap-20 items-start">
          <div className="km-fade flex items-center gap-6 lg:block">
            <GuideCover className="w-[38%] max-w-[180px] lg:w-full lg:max-w-[440px] shrink-0 lg:mx-auto" />
            <div className="lg:hidden min-w-0">
              <p className="km-eyebrow text-[10px] mb-3 text-[#2C4A3B]">Complimentary</p>
              <h1 className="km-serif text-[34px] sm:text-5xl leading-[1.05] text-[#141414]">The Buyer’s <em>Blueprint</em></h1>
            </div>
          </div>
          <div className="km-fade" style={{ animationDelay: ".15s" }}>
            <p className="hidden lg:block km-eyebrow text-[12.5px] mb-6 text-[#2C4A3B]">Complimentary</p>
            <h1 className="hidden lg:block km-serif text-[64px] leading-[1.05] text-[#141414] mb-6">The Buyer’s <em>Blueprint</em></h1>
            <p className="km-serif italic text-[20px] sm:text-[24px] lg:text-[28px] leading-[1.35] text-[#141414] mb-4 lg:mb-6">Everything you need before you start touring.</p>
            <p className="km-body text-[#141414] mb-6 max-w-[520px]">A step-by-step look at buying a home in Dallas–Fort Worth, from getting pre-approved to the day you get your keys.</p>
            <ul className="space-y-2 mb-8 lg:mb-10" data-testid="guide-highlights">
              {BUYER_GUIDE.highlights.map((h) => (
                <li key={h} className="flex items-start gap-3 km-body text-[#141414] !text-[14px] sm:!text-[15px]"><Check size={16} strokeWidth={1.5} className="mt-1 shrink-0 text-[#2C4A3B]" />{h}</li>
              ))}
            </ul>
            <div id="guide-signup" className="bg-white p-6 sm:p-10 scroll-mt-[100px]"><GuideForm /></div>
          </div>
        </div>
      </section>
      <BlueprintPeek />
    </main>
  );
}
